














import React, { useEffect, useState, useMemo } from "react";
import { useLoader } from '../../../../context/LoaderProvider.jsx';

const Engeeniringsubscribedclinets = () => {
    const [data, setData] = useState([]);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [selectedStatusFilter, setSelectedStatusFilter] = useState("");
    const [selectedCityFilter, setSelectedCityFilter] = useState("");
    const [selectedBusinessVerticalFilter, setSelectedBusinessVerticalFilter] = useState("");

    // Search filters - same as FoodPaidClents
    const [searchType, setSearchType] = useState("vendorId");
    const [searchQuery, setSearchQuery] = useState("");

    const { showLoader, hideLoader } = useLoader();
    const [error, setError] = useState(null);

    // Business Vertical options
    const businessVerticalOptions = [
        "FOOD_AND_BEVERAGES",
        "CATERINGS_SERVICES",
        "LOGISTICS_SUPPLY",
        "FRESH_GROCERIES"
    ];

    // Search options - same as FoodPaidClents
    const searchOptions = [
        { value: "vendorId", label: "Vendor ID" },
        { value: "name", label: "Customer Name" },
        { value: "email", label: "Email" },
        { value: "phoneNumber", label: "Mobile Number" },
        { value: "city", label: "City" }
    ];

    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const formatShortDate = (isoString) => {
        if (!isoString) return "—";
        try {
            return new Date(isoString)
                .toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "2-digit",
                })
                .replaceAll("/", "-");
        } catch (e) {
            return "—";
        }
    };

    // Get placeholder text based on search type
    const getPlaceholderText = () => {
        switch (searchType) {
            case "vendorId": return "Search Vendor ID";
            case "name": return "Search Customer Name";
            case "email": return "Search Email";
            case "phoneNumber": return "Search Mobile Number";
            case "city": return "Search City";
            default: return "Search...";
        }
    };

    useEffect(() => {
        const token = localStorage.getItem("authToken");

        if (!token) {
            console.warn("⚠️ No authToken found.");
            setError("Authentication token not found");
            hideLoader();
            return;
        }

        showLoader();

        fetch(
            "https://backend.maamaas.com/subscription/api/subscription/admin/subscriptions?businessVertical=ENGINEERING_SERVICE",
            {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                    Accept: "*/*",
                },
            }
        )
            .then((res) => {
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                return res.json();
            })
            .then((subscriptions) => {
                console.log("API Response:", subscriptions);

                // The API returns an array directly
                const mapped = (Array.isArray(subscriptions) ? subscriptions : [])
                    .map((s, idx) => ({
                        id: s.subscriptionId ?? idx,
                        vendorName: s.customerName || "—",
                        vendorId: s.vendorId || "—",
                        email: s.email || s.customerEmail || "—",
                        mobileNumber: s.customerMobile || "—",
                        city: s.city || "—",
                        businessVertical: s.businessVertical || "—",
                        startDate: s.startDate,
                        endDate: s.endDate,
                        billingCycle: s.billingCycle || "—",
                        totalAmount: s.totalAmount || 0,
                        status: s.status || "—",
                        selectedModules: s.selectedModules || [],
                        remainingDays: s.remainingDays || 0,
                        message: s.message || "",
                    }));

                setData(mapped);
                setError(null);
            })
            .catch((err) => {
                console.error("Error fetching subscriptions:", err);
                setError(err.message);
            })
            .finally(() => {
                hideLoader();
            });
    }, []);

    // Get unique cities for filter
    const uniqueCities = useMemo(() => {
        const cities = data.map(item => item.city).filter(city => city && city !== "—");
        return [...new Set(cities)].sort();
    }, [data]);

    // Get unique statuses for filter
    const uniqueStatuses = useMemo(() => {
        const statuses = data.map(item => item.status).filter(Boolean);
        return [...new Set(statuses)].sort();
    }, [data]);

    // Get unique business verticals for filter
    const uniqueBusinessVerticals = useMemo(() => {
        const verticals = data.map(item => item.businessVertical).filter(Boolean);
        return [...new Set(verticals)].sort();
    }, [data]);

    // Apply filters - including search filters same as FoodPaidClents
    const filteredData = useMemo(() => {
        let result = data;

        // Apply status filter
        if (selectedStatusFilter) {
            result = result.filter(item =>
                item.status && item.status.toLowerCase() === selectedStatusFilter.toLowerCase()
            );
        }

        // Apply city filter
        if (selectedCityFilter) {
            result = result.filter(item =>
                item.city && item.city.toLowerCase() === selectedCityFilter.toLowerCase()
            );
        }

        // Apply business vertical filter
        if (selectedBusinessVerticalFilter) {
            result = result.filter(item =>
                item.businessVertical === selectedBusinessVerticalFilter
            );
        }

        // Apply search query - same as FoodPaidClents
        if (searchQuery.trim()) {
            const query = searchQuery.toLowerCase().trim();
            result = result.filter(item => {
                // Get the field value based on searchType
                let fieldValue;

                // Handle different field names
                if (searchType === "vendorId") {
                    fieldValue = item.vendorId;
                } else if (searchType === "phoneNumber") {
                    fieldValue = item.mobileNumber;
                } else if (searchType === "email") {
                    fieldValue = item.email;
                } else if (searchType === "name") {
                    fieldValue = item.vendorName;
                } else if (searchType === "city") {
                    fieldValue = item.city;
                } else {
                    fieldValue = item[searchType];
                }

                if (!fieldValue || fieldValue === "—") return false;

                // For phone number search, clean non-digits
                if (searchType === "phoneNumber") {
                    const cleanPartnerMobile = fieldValue.toString().replace(/\D/g, '');
                    const cleanQuery = query.replace(/\D/g, '');
                    return fieldValue.toString().toLowerCase().includes(query) ||
                        cleanPartnerMobile.includes(cleanQuery);
                }

                // For other fields
                return fieldValue.toString().toLowerCase().includes(query);
            });
        }

        return result;
    }, [data, selectedStatusFilter, selectedCityFilter, selectedBusinessVerticalFilter, searchType, searchQuery]);

    // Clear all filters
    const clearAllFilters = () => {
        setSelectedStatusFilter("");
        setSelectedCityFilter("");
        setSelectedBusinessVerticalFilter("");
        setSearchQuery("");
        setSearchType("vendorId");
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-12" style={{ marginTop: "10px", }}>
                    {/* Filter Section - Same layout as FoodPaidClents */}
                    <div className="row g-2 mb-3 align-items-center me-0">
                        {/* Search Type Dropdown and Search Input - Side by Side */}
                        <div className="col-md-auto col-12">
                            <div className="d-flex align-items-center" style={{ gap: '10px' }}>
                                {/* Search Type Dropdown */}
                                <div style={{ minWidth: '150px' }}>
                                    <select
                                        className="form-select"
                                        value={searchType}
                                        onChange={(e) => setSearchType(e.target.value)}
                                        style={{ height: "40px" }}
                                    >
                                        {searchOptions.map(option => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Search Input */}
                                <div style={{ minWidth: '200px' }}>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={getPlaceholderText()}
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        style={{ height: "40px" }}
                                    />
                                </div>
                            </div>
                        </div>



                        {/* Business Vertical Filter */}



                        {/* Clear Filters Button */}
                        <div className="col-md-auto col-12">
                            <button
                                className="btn"
                                onClick={clearAllFilters}
                                style={{
                                    backgroundColor: '#6c757d',
                                    color: '#fff',
                                    height: "40px",
                                    padding: "0 15px"
                                }}
                            >
                                Clear Filters
                            </button>
                        </div>

                        {/* Refresh Data Button */}
                        <div className="col-md col-12">
                            <div className="d-flex justify-content-start justify-content-md-end">
                                <button
                                    className="btn"
                                    onClick={() => window.location.reload()}
                                    style={{
                                        backgroundColor: 'rgb(230 109 51)',
                                        color: '#fff',
                                        height: "40px",
                                        padding: "0 20px"
                                    }}
                                >
                                    Refresh Data
                                </button>
                            </div>
                        </div>
                    </div>

                    <div
                        className="user-management-page"
                        style={{
                            overflowY: "auto",
                            height: "59vh",
                            scrollbarWidth: "thin",
                            marginTop: "15px",
                        }}
                    >
                        <div className="user-management-container" style={{ marginLeft: "0px" }}>
                            <div className="user-table-wrapper">
                                <table style={{ width: "100%", fontSize: "0.9rem", borderCollapse: "collapse" }}>
                                    <thead>
                                        <tr>
                                            <th style={tableHeaderStyle}>S.NO</th>
                                            <th style={tableHeaderStyle}>Customer Name</th>
                                            <th style={tableHeaderStyle}>Vendor ID</th>
                                            <th style={tableHeaderStyle}>Email</th>
                                            <th style={tableHeaderStyle}>Phone</th>
                                            <th style={tableHeaderStyle}>City</th>
                                            <th style={tableHeaderStyle}>Vertical</th>
                                            <th style={tableHeaderStyle}>Billing Cycle</th>
                                            <th style={tableHeaderStyle}>Amount (₹)</th>
                                            <th style={tableHeaderStyle}>Start Date</th>
                                            <th style={tableHeaderStyle}>End Date</th>
                                            <th style={tableHeaderStyle}>Remaining</th>
                                            <th style={tableHeaderStyle}>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredData.length === 0 ? (
                                            <tr>
                                                <td colSpan="13" style={tableCellStyle}>
                                                    {error
                                                        ? `⚠️ Error: ${error}`
                                                        : data.length === 0
                                                            ? "No subscription data found"
                                                            : "No data matches the selected filters"}
                                                </td>
                                            </tr>
                                        ) : (
                                            filteredData.map((item, index) => (
                                                <tr key={item.id}>
                                                    <td style={tableCellStyle}>
                                                        {index + 1}
                                                    </td>
                                                    <td style={tableCellStyle}>
                                                        <span style={{ fontWeight: "500" }}>
                                                            {item.vendorName}
                                                        </span>
                                                    </td>
                                                    <td style={tableCellStyle}>
                                                        {item.vendorId}
                                                    </td>
                                                    <td style={tableCellStyle}>
                                                        {item.email}
                                                    </td>
                                                    <td style={tableCellStyle}>
                                                        {item.mobileNumber}
                                                    </td>
                                                    <td style={tableCellStyle}>
                                                        {item.city}
                                                    </td>
                                                    <td style={tableCellStyle}>
                                                        {item.businessVertical}
                                                    </td>
                                                    <td style={tableCellStyle}>
                                                        {item.billingCycle}
                                                    </td>
                                                    <td style={{ ...tableCellStyle, fontWeight: "600", color: "#0b5e42" }}>
                                                        {item.totalAmount > 0
                                                            ? `₹${item.totalAmount.toLocaleString()}`
                                                            : "—"
                                                        }
                                                    </td>
                                                    <td style={tableCellStyle}>
                                                        {formatShortDate(item.startDate)}
                                                    </td>
                                                    <td style={tableCellStyle}>
                                                        {formatShortDate(item.endDate)}
                                                    </td>
                                                    <td style={tableCellStyle}>
                                                        <span style={{
                                                            color: item.remainingDays < 30 ? "#dc3545" : "#28a745",
                                                            fontWeight: "bold",
                                                            backgroundColor: item.remainingDays < 30 ? "#ffe6e6" : "#e6ffe6",
                                                            padding: "4px 8px",
                                                            borderRadius: "20px",
                                                            display: "inline-block"
                                                        }}>
                                                            {item.remainingDays || 0}d
                                                        </span>
                                                    </td>
                                                    <td style={tableCellStyle}>
                                                        <span style={{
                                                            padding: "4px 12px",
                                                            borderRadius: "20px",
                                                            backgroundColor:
                                                                item.status === "ACTIVE" ? "#d4edda" :
                                                                    item.status === "EXPIRED" ? "#f8d7da" :
                                                                        item.status === "PENDING" ? "#fff3cd" :
                                                                            "#e2e3e5",
                                                            color:
                                                                item.status === "ACTIVE" ? "#155724" :
                                                                    item.status === "EXPIRED" ? "#721c24" :
                                                                        item.status === "PENDING" ? "#856404" :
                                                                            "#383d41",
                                                            fontWeight: "600",
                                                            display: "inline-block"
                                                        }}>
                                                            {item.status}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// Styles
const tableHeaderStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
    fontWeight: "bold",
    backgroundColor: "rgb(230 109 51)",
    color: "white",
    padding: "10px 6px",
    fontSize: "0.85rem",
    whiteSpace: "nowrap",
    position: "sticky",
    top: 0,
    zIndex: 10
};

const tableCellStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
    padding: "10px 6px",
    fontSize: "0.85rem",
    verticalAlign: "middle",
    backgroundColor: "white"
};

export default Engeeniringsubscribedclinets;